import { RootState } from '../../store/rootReducer';

export const UnauthorizedContentSelector = (state: RootState) => state.content.unauthorized;
